import { useTheme } from '@mui/material/styles';
import { Box, Button, Chip, Skeleton, Typography } from '@mui/material';
import Card from '@mui/material/Card/Card';
import useGrafSign from 'hooks/useGrafSign';
import { useIntl } from 'react-intl';

type ListGraphSignsProps = { addSign?: Function; select?: Function; updateSign?: Function; onClose?: Function };

const ListGraphSigns = ({ addSign, select, updateSign, onClose }: ListGraphSignsProps) => {
    const intl = useIntl();
    const theme = useTheme();
    const { grafSigns } = useGrafSign();

    return (
        <>
            <Box sx={{ overflowY: 'auto', minWidth: '22vw', height: 'auto', paddingRight: '10px' }}>
                <Typography variant="h4" component={'h2'} sx={{ marginBottom: '20px', fontWeight: '600' }}>
                    {intl.formatMessage({ id: 'MIS_FIRMAS' })}
                </Typography>

                {!grafSigns.length && <Skeleton variant="rounded" width={'100%'} height={230} sx={{ borderRadius: '8px' }} />}
                {grafSigns
                    .sort((sign) => (sign.default ? -1 : 1))
                    .map((sign) => {
                        if (sign.points.length < 1) return null;
                        return (
                            <Card
                                variant="outlined"
                                sx={{ marginBottom: '10px', padding: '10px', ...(select ? { cursor: 'pointer' } : {}) }}
                                onClick={() => select && select(sign)}
                                key={sign._id}
                            >
                                <Box marginBottom={1}>
                                    {sign.description && (
                                        <Typography variant="h4" component={'h3'} marginBottom={1}>
                                            {sign.description}
                                        </Typography>
                                    )}
                                </Box>

                                <Box
                                    sx={{
                                        background: theme.palette.grey[100],
                                        borderRadius: '4px',
                                        minWidth: '20vw',
                                        minHeight: '18dvh',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        position: 'relative'
                                    }}
                                >
                                    <Box
                                        component="img"
                                        src={sign.imageBase64}
                                        alt={intl.formatMessage({ id: 'FIRMA' }) + ' ' + sign?.description}
                                        sx={{
                                            width: '17vw',
                                            height: '16dvh'
                                        }}
                                    />

                                    {sign.default && (
                                        <Chip
                                            sx={{ position: 'absolute', bottom: 2, right: 2 }}
                                            label={intl.formatMessage({ id: 'DEFAULT_SIGN' })}
                                        />
                                    )}
                                </Box>
                                {updateSign && (
                                    <Box display={'flex'} marginTop={1} justifyContent={'flex-end'} alignItems={'center'}>
                                        <Button
                                            variant="text"
                                            sx={{
                                                background: 'transparent',
                                                color: theme.palette.primary.dark,
                                                fontSize: '0.875rem',
                                                fontWeight: 600,
                                                ':hover': { cursor: 'pointer' }
                                            }}
                                            onClick={() => updateSign(sign)}
                                        >
                                            {intl.formatMessage({ id: 'EDITAR' })}
                                        </Button>
                                    </Box>
                                )}
                            </Card>
                        );
                    })}
            </Box>

            <Box sx={{ alignSelf: 'flex-end', mt: '20px', pb: '20px' }}>
                {onClose && (
                    <Button
                        sx={{ background: 'transparent', mr: '12px' }}
                        onClick={() => {
                            onClose();
                        }}
                    >
                        {intl.formatMessage({ id: 'CANCELAR' })}
                    </Button>
                )}
                {addSign && (
                    <Button variant="contained" sx={{ borderRadius: '4px' }} onClick={() => addSign()}>
                        {intl.formatMessage({ id: 'AÑADIR_FIRMA' })}
                    </Button>
                )}
            </Box>
        </>
    );
};

export default ListGraphSigns;
